<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <el-card v-if="this.loadingFormSubmit == false" style="margin:5%; padding:5%; ">
      <h1>Profile</h1>

      <div>
        <h1>Picture upload</h1>
        <h4>current image</h4>
        <img class="imagecontainer" :src="this.form.imageurl" label="current image" />
        <PictureUpload
          v-on:picture-id="handlePictureid($event)"
          v-on:removePictureId="RemovePictureIdLocally($event)"
        />
      </div>
      <el-form :model="form" ref="form" :rules="rules"
      label-position="top" label-width="100px" 
      style="text-align: left;">

        <el-form-item label="First Name" prop="firstname">
          <el-input class="tst-firstname" placeholder="Please input" v-model="form.firstname" required>
            <template slot="prepend">
              <i class="fa fa-user"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="Last Name" prop="lastname">
          <el-input class="tst-lastname" placeholder="Please input" v-model="form.lastname" required>
            <template slot="prepend">
              <i class="fa fa-user"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="Phone Number">
          <el-input class="tst-phoneenumber" placeholder="7187624123" v-model="form.phonenumber" required>
            <template slot="prepend">
              <i class="fa fa-phone"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="Street Adress">
          <el-input class="tst-profile-address" placeholder="21 Green Street" v-model="form.address" required>
            <template slot="prepend">
              <i class="fa fa-map-marker"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="City">
          <el-input class="tst-profile-city" placeholder="New York City" v-model="form.city" required>
            <template slot="prepend">
              <i class="fa fa-map-marker"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="State">
          <el-input class="tst-profile-state" placeholder="New York" v-model="form.state" required>
            <template slot="prepend">
              <i class="fa fa-map-marker"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="Country">
          <el-input class="tst-profile-country" placeholder="USA" v-model="form.country" required>
            <template slot="prepend">
              <i class="fa fa-map-marker"></i>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="Zip Code">
          <el-input class="tst-profile-zip" placeholder="11234" v-model="form.zip" required>
            <template slot="prepend">
              <i class="fa fa-map-marker"></i>
            </template>
          </el-input>
        </el-form-item>
      </el-form>

      <el-button
        class="tst-profile-submit"
        type="primary"
        width="250"
        @click="SubmitForm(CurrentUserProfile.userid)"
      >Update Profile</el-button>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EventService from "@/services/EventService.js";
import PictureUpload from "@/components/utilities/PictureUploadSingle.vue";
export default {
  components: {
    PictureUpload
  },
  data() {
    return {
      CurrentUserProfile: {},
      form: {
        test: "",
        firstname: "",
        lastname: "",
        phonenumber: "",
        pictureid: [],
        address: "",
        city: "",
        state: "",
        country: "",
        zip: "",
        imageurl: ""
      },

      inputRules: [v => (v && v.length != 0) || "This field is required"],
       rules: {
          firstname: [
            { required: true, message: 'Please input first name', trigger: 'blur' },
          ],
          lastname: [
            { required: true, message: 'Please input first name', trigger: 'blur' }
          ]
       },
       invalid: Boolean,
       loadingFormSubmit: false
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  created() {
    EventService.getCurrentUserProfile()
      .then(response => {
        return (this.CurrentUserProfile = response.data);
      })
      .then(currentprofile => {
        this.form.firstname = currentprofile.firstname;
        this.form.lastname = currentprofile.lastname;
        this.form.phonenumber = currentprofile.phonenumber;
        if (currentprofile.pictureid) {
          this.form.pictureid = currentprofile.pictureid;
        }
        this.form.address = currentprofile.address;
        this.form.city = currentprofile.city;
        this.form.state = currentprofile.state;
        this.form.country = currentprofile.country;
        this.form.zip = currentprofile.zip;
        this.form.imageurl = currentprofile.imageurl;
      });

    this.form.firstname = this.CurrentUserProfile.firstname;
  },
  methods: {
    ...mapActions(["changeprofilepicture"]),
    handlePictureid($event) {
      this.form.pictureid.push($event.pictureid);
    },
    RemovePictureIdLocally(img) {
      this.$delete(this.form.pictureid, this.form.pictureid.indexOf(img));
      this.form.imageurl.shift();
    },
    SubmitForm(userid) {

       this.$refs["form"].validate((valid) => {
          if (valid) {
            
          } else {
            this.invalid = true;
            return false;
          }
        });

        if(this.invalid == true){
          this.invalid = false;
          return;
        }

        this.loadingFormSubmit = true;

      EventService.updateProfile(this.form, userid)
        .then(() => {
          EventService.getUserImage(userid).then(response =>
            this.changeprofilepicture(response.data.image)
          );
          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Your profile has been updated"
          });
          this.$router.push({ name: "DashboardAllProperties" });
        })
        .catch(error => {
            console.log(error);
            this.$router.push({ name: "DashboardAllProperties" });
        });
      // }
    }
  }
};
</script>

<style scoped>
.imagecontainer {
  height: 200px;
  max-height: 200px;
}
</style>
